// extracted by mini-css-extract-plugin
export var wordContainer = "_l1-0";